export async function convertFilesToBase64(files?: File[]): Promise<string[]> {
  if (!files) return ['']

  const promises = Array.from(files).map((file) => convertImageToBase64(file))
  return Promise.all(promises)
}

export function convertImageToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => {
      const base64String = (reader.result as string).split(',')[1]
      resolve(base64String)
    }
    reader.onerror = (error) => reject(error)
  })
}
